import React from 'react';

const BoardGameCoverPlaceholder = ({ className = '' }) => {
  return (
    <div className={`flex items-center justify-center w-full h-full ${className}`} aria-hidden="true">
      <svg viewBox="0 0 64 64" className="w-20 h-20 text-primary/70">
        <rect x="6" y="12" width="52" height="40" rx="8" fill="currentColor" opacity="0.12" />
        <path
          d="M32 16c4.4 0 8 3.6 8 8 0 3-1.4 5.6-3.5 7.1l6.2 12.5c0.6 1.2-0.3 2.4-1.6 2.4h-5.3l-2.5-6.6h-3.7l-2.5 6.6h-5.3c-1.3 0-2.2-1.2-1.6-2.4l6.2-12.5C25.4 29.6 24 27 24 24c0-4.4 3.6-8 8-8z"
          fill="currentColor"
          opacity="0.7"
        />
        <circle cx="32" cy="23" r="2.2" fill="currentColor" />
      </svg>
    </div>
  );
};

export default BoardGameCoverPlaceholder;
